import React from 'react';

import ControlButton from '../Shared/ControlButton';

function ShopBox() {
	return (
		<a className="shopbox"
			href="https://tabbycats.club/shop"
			target="_blank"
			rel="noopener noreferrer">
			<ControlButton
				className="shopbox"
				iconName="ShopBox"
				label="Gifts"
				reverseFlow
			/>
		</a>
	);
}

export default ShopBox;



// WEBPACK FOOTER //
// ./src/components/Extension/ShopBox/index.js